<mat-card-content class="w-100-p mb-0 min-h-48 pointer" (click)="openToDosPage()">
    <div class="p-24 stats-wrapper">
        <div fxLayout="column" class="chart-wrapper w-100-p" fxLayoutAlign="space-between center">
            <div fxLayout="row" fxLayoutAlign="space-between center" class="chart-title-wrapper mb-12 w-100-p">
                <div fxLayout="row">
                    <div fxLayoutAlign="center center" class="mr-8">
                        <mat-icon svgIcon="todos"></mat-icon>
                    </div>
                    <label fxLayout="row" fxLayoutAlign="flex-start center" class="chart-title" tabindex="0">
                        {{ 'TODOS.TITLE.TO_DOS' | translate }}
                    </label>
                </div>

                <div fxLayout="row" fxLayoutAlign="flex-end center">
                    <mat-icon class="text-gray-600"> keyboard_arrow_right </mat-icon>
                </div>
            </div>

            <div fxLayout="row" fxLayoutAlign="space-evenly center" class="w-100-p bg-zinc-50 rounded-sm text-gray-600" fxFlex="1 1 auto">
                <div fxLayout="column" fxLayoutAlign="center center">
                    <span class="text-xs">{{ userToDoStatistics.totalCountOfOpenToDos }}</span>
                    <span class="tracking-widest text-xs leading-5 uppercase">{{ 'TODOS.TITLE.OPEN' | translate }}</span>
                </div>

                <div fxLayout="column" fxLayoutAlign="center center">
                    <span class="text-xs">{{ userToDoStatistics.totalCountOfCompletedToDos }}</span>
                    <span class="tracking-widest text-xs leading-5 uppercase">{{ 'GENERAL.STATUS.COMPLETED' | translate }}</span>
                </div>
            </div>
        </div>
    </div>
</mat-card-content>
